/* eslint-disable max-classes-per-file */
import { NgTemplateOutlet } from "@angular/common";
import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { HeaderComponent } from "@components/header/header.component";
import { TabComponent } from "@components/tabs/tab/tab.component";
import { TabsComponent } from "@components/tabs/tabs.component";
import _ from "lodash";
import { BusyService } from "~app/common/components/busy/busy.service";
import { FeatureSettingDTO } from "~app/common/models/featureSetting/FeatureSettingDTO";
import { DirtyFormService } from "~app/common/services/dirty-form.service";
import { FormBinderService } from "~app/common/services/form-binder.service";
import { DirtyTabComponent } from "~app/features/regelverk-viol/dirtyTabComponent";
import { HotkeyDirective } from "../../../../../common/directives/hotkey/hotkey.directive";
import { SystemadministrationService } from "../../systemadministration.service";

@Component({
    selector: "rask-sysadm-featuretoggle",
    templateUrl: "./sysadm-featuretoggle.component.html",
    styleUrls: ["./sysadm-featuretoggle.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        TabsComponent,
        TabComponent,
        NgTemplateOutlet,
        ButtonComponent,
        HotkeyDirective,
        FormsModule,
        ReactiveFormsModule,
        CheckboxComponent
    ]
})
export class SysadmFeaturetoggleComponent extends DirtyTabComponent implements OnInit {

    featureGroups: FeatureSettingGroup[];

    form: UntypedFormGroup;

    private readonly administrationService = inject(SystemadministrationService);
    private readonly busyService = inject(BusyService);
    private readonly formBuilder = inject(UntypedFormBuilder);
    private readonly formBinder = inject(FormBinderService);

    constructor() {
        const dirtyFormService = inject(DirtyFormService);

        super(dirtyFormService);
    }

    restoreChanges() {
        this.init();
    }

    isDirtyCheck(): boolean {
        return this.form?.dirty;
    }

    saveChanges() {
        const flattenedList = _.flatten(_.map(this.featureGroups, "list"));
        this.busyService.addWork(this.administrationService.saveFeatureSettings(flattenedList))
            .subscribe(result => {
                this.initFeatures(result);
            });
    }

    canSave() {
        return this.isDirtyCheck();
    }

    getGroupByName(name: string): UntypedFormGroup {
        let fg;
        (this.form.controls.groups as any).controls.forEach(control => {
            if (control.get("type").value === name) {
                fg = control;
            }
        });
        return fg;
    }

    initFeatures(features: FeatureSettingDTO[]) {
        this.featureGroups = _.chain(features)
            .groupBy("type")
            .map((grouplist, type) => ({ list: grouplist,
                type: type }))
            .value();

        this.createForm();

    }
    createForm() {
        this.form = this.formBuilder.group({
            groups: this.formBuilder.array(this.createFormArray(this.featureGroups))
        });

        this.form.markAsPristine();
    }

    createFormArray(groups: FeatureSettingGroup[]): UntypedFormGroup[] {
        return groups.map(group => this.createFormGroup(group));
    }

    createFormGroup(group: FeatureSettingGroup): UntypedFormGroup {
        return this.formBuilder.group({
            type: group.type,
            list: this.formBuilder.array(this.createFormArrayGroup(group))
        });
    }

    createFormArrayGroup(group: FeatureSettingGroup): UntypedFormGroup[] {
        return group.list.map(item => this.formBinder.CreateGroup(item));
    }

    ngOnInit(): void {
        this.init();
    }

    init(): void {
        this.administrationService.loadFeatureSettings()
            .subscribe(list => {
                this.initFeatures(list);
            });
    }
}

export class FeatureSettingGroup {
    list: FeatureSettingDTO[];
    type: string;
}
